import { ReactElement, FocusEvent, forwardRef } from "react";
import { className } from "../../../shared/helpers";

interface CustomInputProps
{
    type: string;
    name: string;
    label: string;
    autoComplete: string;
    customClassName?: string;
}

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    (props, ref): ReactElement =>
    {
        function setInputClassName(target: HTMLInputElement): void
        {
            if (target.value.length > 0) target.classList.add("has-value");
            else target.classList.remove("has-value");
        }

        function handleBlur(e: FocusEvent<HTMLInputElement>): void
        {
            setInputClassName(e.target as HTMLInputElement);
        }

        return (
            <div {...className("custom-input", props.customClassName)}>
                <input
                    {...{ ref }}
                    type={props.type}
                    id={props.name}
                    name={props.name}
                    autoComplete={props.autoComplete}
                    onBlur={handleBlur}
                />

                <label className="control-label">{props.label}</label>

                <i className="bar" />
            </div>
        );
    }
);

export default CustomInput;
